module.exports = __webpack_public_path__ + "static/alair-logo.16c9c204.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@ua-oira/crimson-tide/dist/logos/alair-logo.svg
// module id = 189
// module chunks = 168707334958949